import {Directive, input} from '@angular/core';

type AsCastContext<T> = T extends {$implicit: infer U} ? {$implicit: U} & Omit<T, '$implicit'> : {$implicit: T};

/**
	* A directive that allows casting a template variable to a specific type.
	* @example
	* ```ts
	*   protected readonly BODY_TEMPLATE_CONTEXT!: {
 $implicit: TableJob | typeof JobsTableComponent.IS_LOADING_JOB;
 columns: IJobsTableColumn[];
 rowIndex: number;
 };
	* ```
	* ```html
	* <ng-template asCast="BODY_TEMPLATE_CONTEXT"
	* let-row
	*  let-columns="columns"
	*  let-rowIndex="rowIndex">
	* ```
	*/
@Directive({
	selector: 'ng-template[ngAs]',
})
export class AsCastDirective<T> {
	readonly ngAs = input.required<T>();

	static ngTemplateContextGuard<T>(directive: AsCastDirective<T>, ctx: any): ctx is AsCastContext<T> {
		return true;
	}
}
